import { AssortmentCategoryType } from '../types';
import {
  FETCH_ASSORTMENT,
  FETCH_ASSORTMENT_FULFILLED,
  FETCH_ASSORTMENT_REJECTED,
} from './actionTypes';
import {
  FetchAssortmentAction,
  FetchAssortmentFulfilledAction,
  FetchAssortmentRejectedAction,
} from './types';

const fetchAssortment = (): FetchAssortmentAction => ({
  type: FETCH_ASSORTMENT,
});

const fetchAssortmentFulfilled = (
  response: AssortmentCategoryType[],
): FetchAssortmentFulfilledAction => ({
  type: FETCH_ASSORTMENT_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchAssortmentRejected = (
  error: ErrorType,
): FetchAssortmentRejectedAction => ({
  type: FETCH_ASSORTMENT_REJECTED,
  payload: {
    error,
  },
});

export {
  fetchAssortment,
  fetchAssortmentFulfilled,
  fetchAssortmentRejected,
};
